export default __webpack_public_path__ + "static/media/benefit-3@3x.5243fa15.png";